angular.module('identity', ['core'])
    .factory('Identity', function ($resource) {
        return $resource('/crm/api/identities/:id', {id: '@id'}, {
            update: {method: 'PUT'}
        });
    })
    .service('IdentityService', function ($rootScope, $http, $q, Identity) {
        this.loadIdentities = () => Identity.query().$promise;
    })
    .component('identityList', {
        templateUrl: 'app/identity/list.html',
        controller: function ($scope, $rootScope, $translate, modals, Identity, IdentityService, toastr) {
            this.tinymceOptions = {
                height: 250,
                statusbar: false,
                plugins: "textcolor code table charmap",
                toolbar1: "undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | blockquote charmap | bullist numlist | outdent indent | table ",
                toolbar2: "forecolor backcolor | fontsizeselect | fontselect | code",
                toolbar_items_size: 'small',
            };

            this.$onInit = () => {
                IdentityService.loadIdentities().then(identities => this.identities = identities);
                this.editing = false;
            }

            this.add = () => {
                this.item = {
                    id: null
                };
                this.editing = true;
            };
            this.edit = identity => {
                this.item = angular.copy(identity);
                this.editing = true;
            };
            this.save = () => {
                let promise
                if (this.item.id !== null) {
                    promise = Identity.update(this.item).$promise;
                } else {
                    promise = Identity.save(this.item).$promise;
                }
                return promise.then(() => this.$onInit());
            };
            this.remove = item => {
                return modals.confirmDelete(item.name, () => Identity.delete(item).$promise.then(() => this.$onInit()));
            };
            this.cancel = () => {
                this.editing = false;
                delete this.item;
            };
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('accountSettingsIdentities', {
            parent: 'accountSettings',
            url: '/settings/identities',
            views: {
                'settings@^': "identityList"
            }
        });
    });
